import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';

import css from './PurchaseStep.module.scss';

interface Props {
  allSteps: StepItems[];
  current: number;
}

const getCss = (current: number, index: number) => {
  const currentStyle = classNames(css.PurchaseStep__Item, css.isCurrent);
  const doneStyle = classNames(css.PurchaseStep__Item, css.isDone);
  const defaultStyle = classNames(css.PurchaseStep__Item);

  if (current === index) {
    return currentStyle;
  } else if (current > index) {
    return doneStyle;
  }
  return defaultStyle;
};

export enum StepItems {
  Customer = 'customer',
  Payment = 'payment',
  Confirmation = 'confirmation',
}

export interface PurchaseStepSetting {
  displayProgress: boolean;
  currentProgress: StepItems | null;
  renderFn: () => JSX.Element | undefined;
}

export type PurchaseStepSettingPair = [
  StepItems[],
  PurchaseStepSetting | undefined,
];

const PurchaseStep = ({ allSteps, current }: Props) => {
  const classes = classNames(css.PurchaseStep);
  const steps = allSteps.map((step, i) => ({
    css: getCss(current, i + 1), // NOTE: step starts with 1, in ModelTypeCourse.tsx
    label: `purchases.purchaseStep.${step}`,
  }));
  const intl = useIntl();

  return (
    <ul className={classes}>
      {steps.map((step, index) => (
        <li key={index} className={step.css}>
          <span className={css.PurchaseStep__StepNumber}>{index + 1}</span>
          <span className={css.PurchaseStep__StepLabel}>
            {intl.formatMessage({ id: step.label })}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default PurchaseStep;
